import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import BusinessList from './pages/BusinessList';
import BusinessDetails from './pages/BusinessDetails';
import AdminDashboard from './pages/AdminDashboard';
import AdminSettings from './pages/AdminSettings';

const AdminRoutes = () => {
  return (
    <AdminLayout>
      <Routes>
        <Route index element={<AdminDashboard />} />
        <Route path="businesses" element={<BusinessList />} />
        <Route path="businesses/:id/*" element={<BusinessDetails />} />
        <Route path="settings" element={<AdminSettings />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminRoutes;